var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.advertising.visible),expression:"advertising.visible"}],staticClass:"ad-popup"},[_c('div',{staticClass:"mask",on:{"click":_vm.closeAdvertising}}),_c('img',{attrs:{"src":_vm.advertising?.image || '',"alt":""},on:{"click":_vm.toRecharge}})])
}
var staticRenderFns = []

export { render, staticRenderFns }